import { ProCard } from '@components'
import KpiCard from '@dashboard/components/KpiCard'
import cn from '@integrations/classnames'
import trackerStyles from '@requests/components/SpendingLimitBarUser/SpendingLimitBarUser.module.scss'
import { tr } from 'mmfintech-commons'
import { ProgressBar } from 'mmfintech-portal-commons'

// Stands in for the spending tracker while the staff member has no accounts: same layout, nothing to track.
function SpendingLimitPlaceholder() {
  return (
    <ProCard className={cn('spending-tracker')} data-test='spending-tracker-empty'>
      <div className={cn(trackerStyles['spending-tracker__layout'], 'spending-tracker__layout')}>
        <div className={cn(trackerStyles['spending-tracker__spent'], 'spending-tracker__spent')}>
          <KpiCard.Header label={tr('FRONTEND.DASHBOARD.SPENDING_LIMIT.MONTHLY', 'Monthly spending limit')} />
          <KpiCard.Value>{tr('FRONTEND.DASHBOARD.SPENDING_LIMIT.NOT_SET', 'No spending limit set')}</KpiCard.Value>
        </div>
        <div className={cn(trackerStyles['spending-tracker__available'], 'spending-tracker__available')}>
          <KpiCard.Sub>
            {tr(
              'FRONTEND.DASHBOARD.SPENDING_LIMIT.NOT_SET_HINT',
              'An administrator sets it when they give you access to make payments.'
            )}
          </KpiCard.Sub>
        </div>
        <div className={cn(trackerStyles['spending-tracker__meter'], 'spending-tracker__meter')}>
          <ProgressBar value={0} max={1} className={cn('spending-tracker-progress')} />
        </div>
      </div>
    </ProCard>
  )
}

export default SpendingLimitPlaceholder
